<script>
    import { onMount } from "svelte";
    import { push } from "svelte-spa-router";
    import { Preferences } from "@capacitor/preferences";
    import NavBar from "../../components/NavBar.svelte";
    import SalesStatusSearch from "./SalesStatusSearch.svelte";
    import SalesStatusList from "./SalesStatusList.svelte";
    import SalesStatusColumnModal from "./SalesStatusColumnModal.svelte";
    import SalesStatusTreeModal from "./SalesStatusTreeModal.svelte";
    import SalesStatusMngmtUploadModal from "./SalesStatusMngmtUploadModal.svelte";
    import { get } from "svelte/store";
    import {
        fetchSalesStatusData,
        fetchSalesPlanWeeks,
        fetchSalesModelIntegrations,
        salesSearch,
        salesPlanWeeks,
        CURRENT_YEAR,
        yearStartDate,
        yearEndDate
    } from "./store.js";
    import toast from "svelte-french-toast";

    let isTreeModalOpen = false;
    let isMngmtUploadOpen = false;

    function handleOpenTreeModal() {
        isTreeModalOpen = true;
    }
    let isColumnModalOpen = false;

    function handleOpenMngmtUploadModal() {
        isMngmtUploadOpen = true;
    }

    function handleOpenColumnModal() {
        isColumnModalOpen = true;
    }

    function handleCloseColumnModal() {
        isColumnModalOpen = false;
    }

    async function handleReset() {
        const weeks = get(salesPlanWeeks);
        salesSearch.set({
            excludeZero: true,
            planWeek: weeks.length > 0 ? weeks[0] : "",
            baseYear: String(CURRENT_YEAR),
            startDate: yearStartDate(CURRENT_YEAR),
            endDate: yearEndDate(CURRENT_YEAR),
            modelIntegration: "",
            treeCheckedIds: [],
            selectedItemGroups: [],
            selectedGroupModels: [],
            itemCode: "",
            perfType: "SALES",
            unitType: "AMOUNT",
            periodType: "MONTH",
            monthBaseType: "DAY",
            yearEndExtend: false,
            isExpanded: true,
        });
        await fetchSalesStatusData();
        toast.success("매출현황 조회 조건이 초기화되었습니다.", { duration: 1500 });
    }

    onMount(async () => {
        // 권한 확인 (로그인 여부)
        try {
            const { value } = await Preferences.get({ key: "retechInfo" });
            if (!value) {
                push("/Login");
                return;
            }
        } catch (e) {
            push("/Login");
            return;
        }

        // 편성주차 목록(최신 편성주차 기본 선택) → 초기 데이터 로드
        await Promise.all([fetchSalesPlanWeeks(), fetchSalesModelIntegrations()]);
        await fetchSalesStatusData();
    });
</script>

<div class="sales-page-container">
    <NavBar activeMenu="매출현황" on:reset={handleReset} on:menuReset={handleReset} />

    <div class="content-wrapper">
        <!-- 상단 조회 조건 영역 (화면 상단 풀 너비 고정) -->
        <SalesStatusSearch
            openTreeModal={handleOpenTreeModal}
            openColumnModal={handleOpenColumnModal}
            openMngmtUploadModal={handleOpenMngmtUploadModal}
        />

        <main class="main-layout">
            <!-- 하단 매출현황 리스트 -->
            <SalesStatusList />
        </main>
    </div>

    <!-- 모달 컴포넌트 -->
    <SalesStatusTreeModal
        isOpen={isTreeModalOpen}
        on:close={() => isTreeModalOpen = false}
    />

    <SalesStatusMngmtUploadModal
        isOpen={isMngmtUploadOpen}
        on:close={() => isMngmtUploadOpen = false}
        on:uploaded={() => fetchSalesStatusData()}
    />

    <SalesStatusColumnModal
        isOpen={isColumnModalOpen}
        on:close={handleCloseColumnModal}
    />
</div>

<style>
    .sales-page-container {
        display: flex;
        flex-direction: column;
        width: 100vw;
        height: 100vh;
        overflow: hidden;
        background: #f1f5f9;
    }
    .content-wrapper {
        flex: 1;
        display: flex;
        flex-direction: column;
        min-height: 0;
        overflow: hidden;
    }
    .main-layout {
        flex: 1;
        display: flex;
        flex-direction: column;
        padding: 10px;
        min-height: 0;
        overflow: hidden;
    }
</style>
